export default __webpack_public_path__ + "static/Inter-ExtraBold-b10df6acf0d5f64b6b2bf807e7bbd2dd.woff";